import { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import {
  useNavigate,
  generatePath,
  useParams,
  useLocation,
} from "react-router-dom";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faUserShield } from "@fortawesome/free-solid-svg-icons";
import "./Doorscanner";
// import logo from "../assets/img/logo-Photoroom.png";
// import logo from "../assets/img/Fire Icon Blue.png";
import logowhite from "../assets/img/Full logo blue.png";
// import logomobile from "../assets/img/Full logo blue.png";
import containertext from "../assets/img/newlogintext.png";
import emaillogo from "../assets/img/email.png";
import passlogo from "../assets/img/pass.png";
// import coblogo from "../assets/img/Vertical logo white.png";
// import logpic from "../assets/img/Loginpic.png";
import backgroundImg from "../assets/img/loginBackground.png";
// import footerLogo from "../assets/img/Full logo white.png";
// import styles from "../assets/css/styles.css";
import Toaster from "./common/Toaster";
import { clearUser, loginUser } from "../store/slices/UserSlice";
// import DoorScanner from "../doorscanner";
import http from "../api/server";
import { Link } from "react-router-dom";
import {
  CHECK_EMAIL_API,
  CLIENT_ONBOARD_API,
  SENT_OTP_TO_CHECK_CLIENT,
  VALIDATE_OTP_NEW_CLIENT,
  GET_USER_CLIENT,
  CHECK_SUBDOMAIN_NAME_NoTOKEN,
} from "../api/apiPath";
import { hostName } from "../config/config";
import imageCompression from "browser-image-compression";

const LogIn = () => {
  const { clientNameParam } = useParams();
  const [step, setStep] = useState("checkEmail"); // checkEmail | resetPassword | login
  const [isNewUserRegistrationStart, setIsNewUserRegistrationStart] =
    useState(false);
  // const [strengthColor, setStrengthColor] = useState("black");
  const [email, setEmail] = useState("");
  const [isEmailExist, setIsEmailExist] = useState(true);
  const [password, setPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [clientName, setClientName] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState(null);
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  const [counter, setCounter] = useState(30);
  const [clientData, setClientData] = useState(null);
  const inputRefs = useRef([]);
  const skipNavStateOnMount = useRef(false);
  const defaultOTPObj = {
    digit1: "",
    digit2: "",
    digit3: "",
    digit4: "",
    digit5: "",
    digit6: "",
  };
  useEffect(() => {
    inputRefs.current[0]?.focus(); // Focus on the first input on component mount
  }, []);
  const [otpValues, setOtpValues] = useState(defaultOTPObj);
  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  // dispatch and navigate
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  //client branding part
  const [summary, setSummary] = useState({});
  const [checking, setChecking] = useState(false);
  const [subdomainMessage, setSubdomainMessage] = useState(null);
  const [portalName, setPortalName] = useState("");
  const [logoPreview, setLogoPreview] = useState(null);
  const fileInputRef = useRef(null);
  const [logoFile, setLogoFile] = useState(null);

  // const [clientSubdomain, setClientSubdomain] = useState("")

  // useEffect(() => {
  //   dispatch(
  //     logoutUser({
  //       userId: userObj?.userId,
  //       userIdentifier: userObj?.userEmail,
  //     })
  //   );
  // }, []);
  useEffect(() => {
    // Only clear local Redux state, don’t hit logout API again
    dispatch(clearUser());
  }, [dispatch]);
  //get email from session storage if exists
  useEffect(() => {
    const savedEmail = sessionStorage.getItem("userEmail");
    if (savedEmail) {
      setEmail(savedEmail); // your state setter
      sessionStorage.removeItem("userEmail");
      setStep("login");
    }
  }, []);
  // Simulated API call for checking if user exists
  const checkEmailAPI = async (email) => {
    try {
      const response = await http.post(CHECK_EMAIL_API, {
        email,
      });
      return response.data;
    } catch (error) {
      return false;
    }
  };
  useEffect(() => {
    // Detect a full page reload using the modern Navigation Timing API
    const navEntries = window.performance.getEntriesByType("navigation");
    const navEntry =
      navEntries && navEntries.length > 0 ? navEntries[0] : undefined;

    const isReload = navEntry && navEntry.type === "reload";

    // If this is a reload on root ("/"), always reset to checkEmail and clear any stale state
    if (isReload && window.location.pathname === "/") {
      // Clear history state so React Router won't see old showRegister on next mounts
      window.history.replaceState(
        {},
        document.title,
        window.location.pathname + window.location.search + window.location.hash
      );

      // Tell the nav-state effect to skip once on this mount
      skipNavStateOnMount.current = true;

      if (step !== "checkEmail") {
        setStep("checkEmail");
      }
    }
  }, []); // Run only once on mount

  // Check if we should show registerUser step from navigation state
  useEffect(() => {
    // If we decided to skip nav-state handling on this mount (reload case), skip once
    if (skipNavStateOnMount.current) {
      skipNavStateOnMount.current = false; // only skip the first run
      return;
    }

    // Normal navigation: if state says "show register", then show register
    if (location.state?.showRegister === true && step !== "registerUser") {
      setStep("registerUser");
      setClientName("");
      setFirstName("");
      setLastName("");
      setPassword("");
      setConfirmPassword("");
      setIsNewUserRegistrationStart(true);
      navigate(location.pathname, {
        replace: true,
        state: null,
      });
    }
  }, [location.state, step]);

  useEffect(() => {
    let timer;
    if (
      isResendDisabled &&
      (step == "enter otp" || step == "enter otp client") &&
      counter > 0
    ) {
      timer = setInterval(() => {
        setCounter((prev) => prev - 1);
      }, 1000);
    } else if (counter === 0) {
      setIsResendDisabled(false);
      clearInterval(timer);
    }
    return () => clearInterval(timer);
  }, [counter, isResendDisabled, step]);
  // registerUser

  const registerClinet = async () => {
    setLoading(true);
    try {
      // const response = await http.post(CLIENT_ONBOARD_API, {
      //   clientName,
      //   firstName,
      //   lastName,
      //   password,
      //   userEmail: email,
      // });
      const response = await onboardClient();
      if (response?.data) {
        setIsNewUserRegistrationStart(false);
        setClientName("");
        setFirstName("");
        setLastName("");
        setPassword("");
        setConfirmPassword("");
        setPortalName("");
        setLogoFile(null);
        setSummary(null);
        return response;
      }
    } catch (error) {
      if (error?.status === 404) {
        setStep("registerUser");
      } else {
        throw new Error(`HTTP error! status: ${error}`);
      }
    }
  };
  const handleResend = async () => {
    // Trigger resend OTP logic here
    console.log("Resending OTP...");
    setCounter(30);
    setIsResendDisabled(true);
    if (isNewUserRegistrationStart) {
      const response = await sendOTPToVeifyClient();
      if (response.status !== 400) {
        setStep("enter otp client");
        setValidate({
          hasLow: false,
          hasCap: false,
          hasNumber: false,
          has8digit: false,
        });
      } else {
        setStep("registerUser");
        setLoginError(response?.data?.message);
      }
    } else {
      const response = await resetPasswordAPI(email, password);
      if (response.status !== 400) {
        setStep("enter otp");
      } else {
        setLoginError(response?.response?.data?.message);
        setStep("reset password");
      }
    }
    setOtpValues(defaultOTPObj);
  };
  // Simulated API call for password reset
  // Real API call for password reset
  const resetPasswordAPI = async (email, password) => {
    try {
      const response = await http.post("/api/Auth/reset-password", {
        email,
        password,
      });
      return response;
    } catch (error) {
      return error;
    }
  };
  const handleClientDetails = async (e) => {
    setLoading(true);
    e.preventDefault();
    if (password.length < 8) {
      setStep("registerUser");
      setLoginError("Password must be at least 8 characters long!");
      setLoading(false);
      return;
    }
    if (password !== confirmPassword) {
      setStep("registerUser");
      setLoginError("Passwords do not match!");
      setLoading(false);
      return;
    }
    if (!isValidEmailOrMobile(email)) {
      setLoginError("Please enter a valid email address.");
      setStep("registerUser");
      setLoading(false);
      return;
    }
    setStep("clientBranding");
    setLoading(false);
  };
  const isValidEmailOrMobile = (value) => {
    // Email regex
    // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    //.com or .in    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const additionalemailRegex = /^[^\s@]+@[^\s@]+\.(com|in|co\.in|co\.uk)$/;
    // General mobile regex: optional +, 8-15 digits
    // const mobileRegex = /^\+?\d{8,15}$/;
    // const valid1 = emailRegex.test(value);
    // const valid2 = mobileRegex.test(value);
    const valid3 = additionalemailRegex.test(value);
    return valid3;
  };
  const handleUserRegister = async (e) => {
    setLoading(true);
    e.preventDefault();
    if (password.length < 8) {
      setStep("registerUser");
      setStep("registerUser");
      setLoginError("Password must be at least 8 characters long!");
      setLoading(false);
      return;
    }
    if (password !== confirmPassword) {
      setStep("registerUser");
      setLoginError("Passwords do not match!");
      setLoading(false);
      return;
    }
    const response = await sendOTPToVeifyClient();
    if (response.status !== 400) {
      setStep("enter otp client");
      setValidate({
        hasLow: false,
        hasCap: false,
        hasNumber: false,
        has8digit: false,
      });
    } else {
      setStep("registerUser");
      setLoginError(response?.data?.message);
    }

    setLoading(false);
  };

  const onboardClient = async () => {
    let compreedFile = null;
    if (logoFile != null) {
      const options = {
        maxSizeMB: 0.5, // Target size
        maxWidthOrHeight: 1024, // Optional resize
        useWebWorker: true,
        initialQuality: 0.7, // Start compression at 70%
      };
      const compressedFile = await imageCompression(logoFile, options);
      compreedFile = new File([compressedFile], logoFile.name, {
        type: logoFile.type,
      });
    }
    const formData = new FormData();
    const fullUrl = summary.subdomain;
    formData.append("createClient.ClientName", clientName);
    formData.append("createClient.UserEmail", email);
    formData.append("createClient.Password", password);
    formData.append("createClient.FirstName", firstName);
    formData.append("createClient.LastName", lastName);
    formData.append("clientBranding.ClientLogo", compreedFile);

    formData.append("clientBranding.ClientSubDomain", fullUrl);
    formData.append("clientBranding.ClientSubDomainName", portalName);
    try {
      const response = await fetch(hostName + CLIENT_ONBOARD_API, {
        method: "POST",
        body: formData,
      });
      if (response?.status === 200) {
        return response;
      } else {
        return null;
      }
    } catch (err) {
      console.error("Error during client onboarding:", err);
      return null;
    }
  };

  //RegisterUser
  useEffect(() => {
    const fetchClients = async () => {
      const payload = { userEmail: email };

      try {
        const response = await http.get(GET_USER_CLIENT, {
          params: payload,
        });

        console.log("Client data:", response.data);
        setClientData(response.data);
      } catch (error) {
        console.error(
          "Error fetching clients:",
          error.response?.data || error.message
        );
      }
    };

    if (step === "getUserClients") {
      fetchClients();
    }
  }, [step, email]);

  const sendOTPToVeifyClient = async () => {
    try {
      const response = await http.post(SENT_OTP_TO_CHECK_CLIENT, {
        clientName: clientName,
        userEmail: email,
      });
      return response;
      // return response;
    } catch (error) {
      return error;
    }
  };

  const verifyOTP = async () => {
    const otpString = Object.values(otpValues).join("");
    try {
      const response = await http.post("/api/Auth/verify-otp", {
        email,
        otp: otpString,
        password,
      });
      return response;
    } catch (error) {
      return error;
    }
  };

  const validateOTPForNewClient = async () => {
    const otpString = Object.values(otpValues).join("");
    let resData = "";
    try {
      const response = await http.post(VALIDATE_OTP_NEW_CLIENT, {
        userEmail: email,
        otp: otpString,
      });
      if (response.status !== 400) {
        resData = registerClinet();
      }
      return resData;
    } catch (error) {
      return error;
    }
  };

  // const handleEmailSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoginError("");
  //   setLoading(true);
  //   const exists = await checkEmailAPI(email);

  //   if (exists) {
  //     // setStep('resetPassword');
  //     if (exists["passwordSet"]) {
  //       setStep("login");
  //     } else {
  //       setStep("change password");
  //     }
  //   } else {
  //     setIsEmailExist(false);
  //     // navigate("/signin")
  //     // setStep("not found");
  //   }
  //   setLoginError("");
  //   setLoading(false);
  // };
  //
  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    setLoginError("");
    setLoading(true);

    try {
      const response = await checkEmailAPI(email);

      if (response) {
        const userExist = response?.exists;
        const setPass = response?.passwordSet;
        const isActive = response?.isActive;

        if (userExist && setPass && isActive) {
          if (clientNameParam) {
            setStep("login");
          } else {
            setStep("getUserClients");
          }
        } else if (!isActive) {
          setLoginError(
            "Your account is inactive, please contact the admin to reactivate your account."
          );
        } else if (userExist && !setPass) {
          setStep("change password");
        } else {
          setIsEmailExist(false);
        }
      } else {
        setIsEmailExist(false);
      }
    } catch (err) {
      setLoginError("Something went wrong. Please try again.");
    }

    setLoading(false);
  };

  const handleVerifyOTP = async (e) => {
    setLoading(true);
    e.preventDefault();
    setLoginError("");

    if (isNewUserRegistrationStart) {
      const response = await validateOTPForNewClient();
      if (
        response?.data?.message == "Invalid OTP." ||
        response?.data?.message == "OTP is expired. Please re-generate OTP." ||
        response?.data?.message ==
          "OTP is already used. Please re-generate OTP."
      ) {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: response?.data?.message,
        });
        setOtpValues(defaultOTPObj);
        setLoginError(response?.data?.message);
        setStep("enter otp client");
      } else {
        setToastData({
          toastShow: true,
          toastType: "success",
          toastString:
            "Client registered successfully. Please login using your credentials.",
        });
        resetValue();
        setStep("checkEmail");
      }
      setLoading(false);
    } else {
      const response = await verifyOTP();
      if (
        response?.data?.message == "Invalid OTP." ||
        response?.data?.message == "OTP is expired. Please re-generate OTP." ||
        response?.data?.message ==
          "OTP is already used. Please re-generate OTP."
      ) {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: response?.data?.message,
        });
        setOtpValues(defaultOTPObj);
        setLoginError(response?.data?.message);
        setStep("enter otp");
      } else {
        setToastData({
          toastShow: true,
          toastType: "success",
          toastString: response?.data?.message,
        });
        resetValue();
        setStep("login");
      }
      setLoading(false);
    }
  };
  const handleResetPassword = async (e) => {
    e.preventDefault();
    setLoginError("");
    if (password.length < 8) {
      setLoginError("Password must be at least 8 characters.");
      return;
    }
    if (password !== confirmPassword) {
      setLoginError("Passwords do not match.");
      return;
    }
    const response = await resetPasswordAPI(email, password);
    if (response.status !== 400) {
      //resetValue();
      setStep("enter otp");
    } else {
      setLoginError(response?.response?.data?.message);
      //setConfirmPassword("");
      //setPassword("");
      // setStep("login");
    }
    setLoading(false);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    // console.log("check client", clientSubdomain);
    setLoading(true);
    setLoginError(null);
    dispatch(loginUser({ email, password, application: "Assure Fire AI" }))
      .then((res) => {
        setLoading(false);
        if (res?.payload !== undefined) {
          // localStorage.setItem('token', res?.payload?.token);
          const { isAdmin } = res.payload;
          setEmail("");
          setPassword("");
          if (isAdmin) {
            navigate(
              generatePath("/client/:clientNameParam/adminDashboard", {
                clientNameParam,
              }),
              { replace: true }
            );

            return;
          }
          if (clientNameParam) {
            navigate(
              generatePath("/client/:clientNameParam/property-form", {
                clientNameParam,
              }),
              { replace: true }
            );
          }
          // else if(clientSubdomain && clientSubdomain !== ""){
          //   const afterClient = clientSubdomain.split("/client/")[1];
          //   const firstSegment = afterClient?.split("/")[0] || "";
          //   navigate(
          //     generatePath("/client/:firstSegment/property-form", {
          //       firstSegment,
          //     })
          //   );
          // }
          else {
            // Fallback if login happened on "/" or "/client" (no :clientName in URL).
            // Choose the right destination for your app. For now, send them to "/client".
            navigate("/client");
            setStep("checkEmail");
          }
        } else {
          if (res?.error?.message === "Request failed with status code 401") {
            setLoginError("Access Denied! Invalid password");
          } else {
            setLoginError(res?.error?.message);
          }
        }
      })
      .catch((err) => {
        setLoading(false);
        setLoginError(err.message || "Login failed");
      });
  };
  const [validate, setValidate] = useState({
    hasLow: false,
    hasCap: false,
    hasNumber: false,
    has8digit: false,
  });
  const strengthNew = Object.values(validate).reduce((a, item) => a + item, 0);
  const validatePassword = (password) => {
    if (password.match(/\d+/g)) {
      setValidate((o) => ({ ...o, hasNumber: true }));
    } else {
      setValidate((o) => ({ ...o, hasNumber: false }));
    }

    if (password.match(/[A-Z]+/g)) {
      setValidate((o) => ({ ...o, hasCap: true }));
    } else {
      setValidate((o) => ({ ...o, hasCap: false }));
    }

    if (password.match(/[a-z]+/g)) {
      setValidate((o) => ({ ...o, hasLow: true }));
    } else {
      setValidate((o) => ({ ...o, hasLow: false }));
    }

    if (password.length > 7) {
      setValidate((o) => ({ ...o, has8digit: true }));
    } else {
      setValidate((o) => ({ ...o, has8digit: false }));
    }
  };
  const feedback = {
    1: "Password is too weak!",
    2: "It's still weak! ",
    3: "You almost there!",
    4: "Great!! now your password is strong",
  }[strengthNew];

  const strongText = "Great!! now your password is strong";
  const [enableCountniue, setEnableCountniue] = useState(true);

  useEffect(() => {
    if (!password && !confirmPassword) return;
    if (
      password.length > 7 &&
      confirmPassword.length > 7 &&
      password.length === confirmPassword.length &&
      password === confirmPassword &&
      feedback === strongText
    ) {
      setEnableCountniue(false);
    } else {
      setEnableCountniue(true);
    }
  }, [password, confirmPassword, feedback]);

  const handlePassword = (value) => {
    setLoginError("");
    setPassword(value);
    validatePassword(value);
  };
  const handleEmail = (e) => {
    setLoginError("");
    setIsEmailExist(true);
    setEmail(e.target.value);
  };
  const resetValue = () => {
    setConfirmPassword("");
    setLoading(false);
    setPassword("");
    // setEmail("");
    setLoginError("");
    setIsEmailExist(true);
    setValidate({
      hasLow: false,
      hasCap: false,
      hasNumber: false,
      has8digit: false,
    });
    setOtpValues(defaultOTPObj);
  };

  const setOTPValue = (value, digitKey, index) => {
    setOtpValues((prevOtpValues) => ({
      ...prevOtpValues,
      [digitKey]: value.substring(value.length - 1), // Take only the last character entered
    }));
    // Auto-focus the next input field if a digit is entered and it's not the last field
    if (value.length === 1 && index !== 5) {
      inputRefs.current[index + 1].focus();
    }
  };
  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
    setOtpValues(defaultOTPObj);
  };
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && index > 0 && e.target.value === "") {
      inputRefs.current[index - 1]?.focus();
    } else if (e.key === "ArrowRight" && index < length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordMain, setShowPasswordMain] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const mainScreenShowPass = () => {
    setShowPasswordMain((prev) => !prev);
  };
  const resetScreenShowPass = () => {
    setShowPassword((prev) => !prev);
  };

  const confirmShowPassword = () => {
    setShowConfirmPassword((prev) => !prev);
  };
  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").trim();

    if (pastedData.length === 6 && /^\d+$/.test(pastedData)) {
      const optArray = pastedData.split("");

      const defaultOTPObj = {
        digit1: optArray[0],
        digit2: optArray[1],
        digit3: optArray[2],
        digit4: optArray[3],
        digit5: optArray[4],
        digit6: optArray[5],
      };

      setOtpValues(defaultOTPObj);
      // Optionally focus the last input after pasting
      inputRefs.current[5]?.focus();
    }
  };
  const handleFirstName = (e) => {
    setFirstName(e.target.value);
  };
  const handleUploadLogo = () => {
    fileInputRef.current.click();
  };

  const handleLogoFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 4 * 1024 * 1024) {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString:
            "File size exceeds 4MB limit. Please choose a smaller file.",
        });
        e.target.value = null; // Clear the input
        return;
      } else {
        setLogoFile(file);
        setLogoPreview(URL.createObjectURL(file));
      }
    }
  };

  useEffect(() => {
    const checkSubdomain = async () => {
      if (!portalName.trim()) {
        setSubdomainMessage(null);
        return;
      }

      const subdomain = portalName.replace(/\s+/g, "").toLowerCase();
      setChecking(true);
      try {
        // const response = await fetch(
        //   `${hostName}${CHECK_SUBDOMAIN_NAME_NoTOKEN}?subdomain=${subdomain}`,
        // );
        const response = await http.get(
          CHECK_SUBDOMAIN_NAME_NoTOKEN + `?subdomain=${subdomain}`
        );

        //const data = await response.json();
        const data = response.data;
        setSummary(data);
        // 🔹 Example response:
        // { available: false, suggestions: ["abc1", "abc2", "abc3"] }

        if (data?.available === false) {
          setSubdomainMessage({
            type: "error",
            suggestions: data?.suggestions || [],
          });
        } else {
          setSubdomainMessage({ type: "success" });
        }
      } catch (err) {
        console.error("Error checking subdomain:", err);
        setSubdomainMessage(null);
      } finally {
        setChecking(false);
      }
    };

    const delayDebounce = setTimeout(checkSubdomain, 600); // debounce
    return () => clearTimeout(delayDebounce);
  }, [portalName]);

  useEffect(() => {
    if (step !== "registerUser") return;

    const path = location.pathname.replace(/\/+$/, "");

    if (path === "/client" || path.startsWith("/client/")) {
      const search = location.search || "";
      const hash = location.hash || "";
      if (location.pathname !== "/") {
        navigate("/" + search + hash, {
          replace: true,
          state: { showRegister: true },
        });
      }
    }
  }, [step, location.pathname, location.search, location.hash, navigate]);

  return (
    <div className="main_body">
      <div
        className="back-image-login"
        style={{
          backgroundImage: `url(${backgroundImg})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "left bottom",
          backgroundSize: "contain",
          width: "100%",
          height: "100vh",
        }}
      ></div>
      <div className="logopg">
        <img
          src={logowhite}
          className="login-page-logo desktop-logo"
          alt="logo"
        />
        {/* <img
          src={logomobile}
          className="login-page-logo mobile-logo"
          alt="logo"
        /> */}
      </div>
      <div>
        <img
          src={containertext}
          className="login-page-containertext"
          alt="logo"
        />
      </div>

      <Toaster
        show={toastData.toastShow}
        toastType={toastData.toastType}
        title={toastData.toastString}
        theme={"dark"}
        position="top-center"
        closeButton={() => {
          closeButton();
        }}
      />

      {step === "registerUser" && (
        <div className="login-container d-flex justify-content-center">
          <div className="card login-card align-items-center">
            <div className="d-flex w-100 flex-column text-start mb-3 ">
              <h3 className="login-card-text fw-bold white-text">
                Client Onboarding
              </h3>
              <p className="login-card-text text">
                Enter the client details to continue
              </p>
            </div>
            <div className="d-flex w-100 mt-3 flex-column align-items-center gap-2">
              {/*  Register Form */}
              <form
                className="w-100 register-form "
                onSubmit={handleClientDetails}
              >
                {/* Row 1 */}
                <div className="row mb-2">
                  <div className="col-md-6 mb-2">
                    <div className="">
                      <p className="logtext mb-0 text-start">
                        Client Name<span style={{ color: "red" }}>*</span>
                      </p>
                      <input
                        type="text"
                        className="form-controlinputbox"
                        style={{ width: "100%", height: "40px" }}
                        placeholder="Enter client name"
                        value={clientName}
                        onChange={(e) => {
                          setClientName(e.target.value);
                          setPortalName(
                            e.target.value
                              ?.trim()
                              .toLowerCase()
                              .replace(/\s+/g, "")
                          );
                        }}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-6">
                    <div>
                      <p className="logtext mb-0 text-start">
                        First Name<span style={{ color: "red" }}>*</span>
                      </p>
                      <input
                        type="text"
                        className="form-controlinputbox"
                        style={{ width: "100%", height: "40px" }}
                        placeholder="Enter first name"
                        value={firstName}
                        onChange={handleFirstName}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-6">
                    <div className="mb-2">
                      <p className="logtext mb-0 text-start">
                        Last Name<span style={{ color: "red" }}>*</span>
                      </p>
                      <input
                        type="text"
                        className="form-controlinputbox"
                        style={{ width: "100%", height: "40px" }}
                        placeholder="Enter last name"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-2">
                      <p className="logtext mb-0 text-start">
                        Email Address<span style={{ color: "red" }}>*</span>
                      </p>
                      <input
                        type="email"
                        className="form-controlinputbox"
                        style={{ width: "100%", height: "40px" }}
                        placeholder="Enter email"
                        value={email}
                        onChange={handleEmail}
                        required
                      />
                    </div>
                  </div>
                </div>

                {/* Row 3 */}
                <div className="row mb-3">
                  <div className="col-md-6">
                    <div className="mb-2">
                      <p className="logtext mb-0 text-start">
                        Password<span style={{ color: "red" }}>*</span>
                      </p>
                      <div className="form-floating position-relative">
                        <input
                          type={showPasswordMain ? "text" : "password"}
                          className="form-controlinputbox"
                          style={{ width: "100%", height: "40px" }}
                          placeholder="Enter password"
                          value={password}
                          onChange={(e) => handlePassword(e.target.value)}
                          required
                        />
                        <i
                          className={`fa-solid ${
                            showPasswordMain ? "fa-eye-slash" : "fa-eye"
                          } fa-sm  `}
                          style={{
                            position: "absolute",
                            right: "12px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            color: "#6c6c6c",
                          }}
                          onClick={mainScreenShowPass}
                        ></i>
                      </div>
                      {password.length > 0 && (
                        <>
                          <progress
                            className={`password strength-${strengthNew}`}
                            value={strengthNew}
                            max="4"
                          />
                          <div className={`feedback strength-${strengthNew}`}>
                            {feedback}
                          </div>
                        </>
                      )}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="mb-2 ">
                      <p className="logtext mb-0 text-start">
                        Re-enter Password<span style={{ color: "red" }}>*</span>
                      </p>
                      <div className="form-floating position-relative">
                        <input
                          type={showConfirmPassword ? "text" : "password"}
                          className="form-controlinputbox "
                          style={{ width: "100%", height: "40px" }}
                          placeholder="Re-enter password"
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          required
                        />
                        <i
                          className={`fa-solid ${
                            showConfirmPassword ? "fa-eye-slash" : "fa-eye"
                          } fa-sm `}
                          style={{
                            position: "absolute",
                            right: "12px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            color: "#6c6c6c",
                          }}
                          onClick={confirmShowPassword}
                        ></i>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div
                      className={`feedback strength-1`}
                      style={{ textAlign: "center" }}
                    >
                      {loginError}
                    </div>
                  </div>
                </div>

                {/* Submit Button */}
                <div className="row">
                  <div className="col-12">
                    <button
                      type="submit"
                      className="btn-primary  w-100"
                      onClick={(e) => handleClientDetails(e)}
                      disabled={
                        loading ||
                        email.length === 0 ||
                        clientName.length === 0 ||
                        firstName.length === 0 ||
                        lastName.length === 0 ||
                        password.length === 0
                      }
                    >
                      {loading ? "Please Wait..." : "Continue"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <div className="terms-conditions">
              <p className="mb-0">
                BY CONTINUING, YOU AGREE TO OUR{" "}
                <Link
                  to="/PrivacyPolicy"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  TERMS OF SERVICE
                </Link>{" "}
                AND{" "}
                <Link
                  to="/PrivacyPolicy"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  PRIVACY POLICY
                </Link>
              </p>
              <p className="mt-4 mb-0">COPYRIGHT@2025, FIRE INSPECT</p>
            </div>
          </div>
        </div>
      )}

      {step === "clientBranding" && (
        <div
          className="login-container client-login-container d-flex justify-content-center"
          // style={{ top: "9vh", width: "34%", height: "91vh" }}
        >
          <div className="card login-card align-items-center">
            <div className="d-flex w-100 flex-column text-start mb-3">
              <h3 className=" login-card-text fw-bold white-text">
                Client Branding
              </h3>
              <p className="login-card-text text">
                Enter the client branding details to continue
              </p>
            </div>
            <div className="d-flex w-100 mt-3 flex-column align-items-center gap-2">
              {/*  Register Form */}
              <form
                className="w-100 register-form "
                onSubmit={handleUserRegister}
              >
                {/* Row 1 */}
                <div className="row mb-2">
                  <div className="text-start">
                    <p className="logtext mb-0">Logo</p>
                  </div>
                  <div className="upload-section d-flex align-items-center">
                    <div className="upload-box" onClick={handleUploadLogo}>
                      <div className="upload-content">
                        {logoPreview ? (
                          <img
                            src={logoPreview}
                            alt="Uploaded Logo"
                            className="uploaded-logo"
                          />
                        ) : (
                          <img
                            style={{ height: "100px", width: "100px" }}
                            alt="Click to upload"
                          />
                        )}
                      </div>
                    </div>
                    <div className="upload-info ms-1">
                      <p
                        className="upload-text"
                        style={{ fontSize: "12px", color: "black" }}
                      >
                        Drag & drop your file here or{" "}
                        <span
                          className="browse-link"
                          onClick={handleUploadLogo}
                        >
                          click to browse
                        </span>
                      </p>
                      <small
                        className="upload-hint"
                        style={{ fontSize: "12px" }}
                      >
                        PNG, JPG up to 4MB
                      </small>
                      <p
                        className="remark-text mb-0"
                        style={{ fontSize: "11px", textAlign: "justify" }}
                      >
                        <span style={{ color: "red" }}>*</span> Logo will be
                        used in all reports and communication. <br></br>Logo can
                        be changed in the settings.
                      </p>
                    </div>
                    <input
                      type="file"
                      accept="image/png, image/jpeg, image/jpg"
                      style={{ display: "none" }}
                      ref={fileInputRef}
                      onChange={handleLogoFileChange}
                    />
                  </div>
                  {/* <div className="text-start">
                    <p
                      className="remark-text mb-0"
                      style={{ fontSize: "11px" }}
                    >
                      <span style={{ color: "red" }}>*</span> Logo will be used
                      in all reports and communication. Logo can be changed in
                      the settings.
                    </p>
                  </div> */}
                </div>

                {/* Row 3 */}
                <div className="row mb-2">
                  {/* Portal Name */}
                  <div className="mb-2 mt-2 text-start">
                    <p className="logtext mb-0 text-start">
                      Client Portal Name<span style={{ color: "red" }}>*</span>
                    </p>
                    <input
                      type="text"
                      className="form-controlinputbox  text-start"
                      style={{ width: "100%" }}
                      placeholder="Enter portal name"
                      value={portalName}
                      onChange={(e) => setPortalName(e.target.value)}
                    />
                    <div className="text-start">
                      <p
                        className="remark-text mb-0"
                        style={{ fontSize: "11px" }}
                      >
                        <span style={{ color: "red" }}>*</span> Once submitted,
                        the Client Portal Name cannot be changed.
                      </p>
                    </div>

                    {checking && (
                      <small className="text-info">
                        Checking availability...
                      </small>
                    )}

                    {!checking && subdomainMessage?.type === "success" && (
                      <small className="text-success">
                        Subdomain available
                      </small>
                    )}

                    {!checking && subdomainMessage?.type === "error" && (
                      <div>
                        <small className="text-danger d-block">
                          Subdomain already taken.
                        </small>
                        {subdomainMessage.suggestions?.length > 0 && (
                          <small
                            className="text-success"
                            style={{ color: "greenyellow" }}
                          >
                            Suggested alternatives:{" "}
                            {subdomainMessage.suggestions.join(", ")}
                          </small>
                        )}
                      </div>
                    )}
                  </div>

                  {/* Portal URL */}
                  <div className="mb-2 text-start">
                    <p className="logtext mb-0 text-start">
                      Client Portal Url(s)
                    </p>
                    <div
                      className="genurl"
                      style={{ width: "auto", borderColor: "black" }}
                    >
                      <span style={{ margin: "10px" }}>
                        {summary?.available ? (
                          <span>{summary?.subdomain}</span>
                        ) : (
                          summary?.suggestionUrls?.map((url, index) => (
                            <span key={index}>
                              {url}
                              <br />
                            </span>
                          ))
                        )}
                      </span>
                    </div>
                    <div className="text-start">
                      <p
                        className="remark-text mb-0"
                        style={{ fontSize: "11px" }}
                      >
                        <span style={{ color: "red" }}>*</span> Once submitted,
                        the Client Portal URL cannot be changed.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Submit Button */}
                <div className="row">
                  <div className="col-12">
                    <button
                      type="submit"
                      className="btn-primary  w-100"
                      onClick={handleUserRegister}
                      disabled={
                        loading ||
                        email.length === 0 ||
                        subdomainMessage === null ||
                        subdomainMessage?.type === "error"
                      }
                    >
                      {loading ? "Please Wait..." : "Continue"}
                    </button>
                  </div>
                </div>
                <div className="col-sm-12 mb-3 mt-2 flex-column gap-3 flex-sm-row text-end">
                  <button
                    type="back"
                    className="buttonStyle"
                    style={{
                      color: "black",
                    }}
                    onClick={() => {
                      setStep("registerUser");
                    }}
                  >
                    <i className="fa fa-arrow-left me-2"></i> Back to Client
                    Onboarding
                  </button>
                </div>
              </form>
            </div>
            {subdomainMessage?.type === "error" ? (
              <div></div>
            ) : (
              <div className="terms-conditions">
                <p className="mb-0">
                  BY CONTINUING, YOU AGREE TO OUR{" "}
                  <Link
                    to="/PrivacyPolicy"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    TERMS OF SERVICE
                  </Link>{" "}
                  AND{" "}
                  <Link
                    to="/PrivacyPolicy"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    PRIVACY POLICY
                  </Link>
                </p>
                <p className="mt-4">COPYRIGHT@2025, FIRE INSPECT</p>
              </div>
            )}
          </div>
        </div>
      )}

      {step === "checkEmail" && (
        <div className="login-container d-flex justify-content-center">
          <div className="card login-card align-items-center">
            <div className="d-flex w-100 flex-column text-start mb-3 ">
              <h3 className=" login-card-text fw-bold white-text">Welcome</h3>
              <p className=" login-card-text text">
                Enter your email address to continue
              </p>
            </div>
            <div className=" d-flex w-100 mt-3 flex-column align-items-center gap-2">
              <form className="w-100" onSubmit={handleEmailSubmit}>
                <div className="col-sm-12 mb-3">
                  <div className="form-floating">
                    <p className="logtext text-start">Email Address</p>
                    <input
                      type="email"
                      className="form-controlinputbox  ps-5"
                      id="floatingInput"
                      value={email}
                      onChange={(e) => handleEmail(e)}
                      required
                    />
                    <img src={emaillogo} className="input-icon" alt="logo" />
                  </div>
                </div>
                <>
                  {!isEmailExist && (
                    <div
                      className="col-sm-12 text-danger mb-2"
                      style={{ fontSize: "11px" }}
                    >
                      {window.location.pathname.split("/")[1] !== "" ? (
                        <div className="errormes">
                          The user is not associated with this client.
                          <br />
                          Please verify the email address or URL.
                        </div>
                      ) : (
                        "User does not exist, please check the Email."
                      )}
                    </div>
                  )}
                </>

                <div className="col-sm-12">
                  <button
                    type="submit"
                    disabled={loading || email?.length === 0}
                    className="btn-primary mb-3 w-100"
                  >
                    {loading ? "Please Wait..." : "Continue"}
                  </button>
                </div>
                <div className="col-sm-12 mb-3 mt-2 flex-column gap-3 flex-sm-row text-end">
                  {/* <a href="#">Reset your password</a> */}
                  <button
                    className="buttonStyle"
                    onClick={() => {
                      const path = location.pathname.replace(/\/+$/, "");
                      if (path === "/client" || path.startsWith("/client/")) {
                        navigate("/", {
                          replace: true,
                          state: { showRegister: true },
                        });
                      } else {
                        setStep("registerUser");
                        setClientName("");
                        setFirstName("");
                        setLastName("");
                        setPassword("");
                        setConfirmPassword("");
                        setIsNewUserRegistrationStart(true);
                      }
                    }}
                    style={{
                      color: "black",
                    }}
                  >
                    Register New Client
                  </button>
                </div>

                <>
                  {loginError && (
                    <div className="text-danger">{loginError}</div>
                  )}
                </>

                {/* <div className="col-sm-12 mb-4 text-center">
                  <Link to="/signin">Get help signing in</Link>
                </div> */}
              </form>
            </div>
            <div className="terms-conditions">
              <p className="mb-0">
                BY CONTINUING, YOU AGREE TO OUR{" "}
                <Link
                  to="/PrivacyPolicy"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  TERMS OF SERVICE
                </Link>{" "}
                AND{" "}
                <Link
                  to="/PrivacyPolicy"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  PRIVACY POLICY
                </Link>
              </p>
              <p className="mt-4 mb-0">COPYRIGHT@2025, FIRE INSPECT</p>
            </div>
          </div>
        </div>
      )}

      {step === "getUserClients" && (
        <div className="login-container d-flex justify-content-center">
          <div className="card login-card align-items-center">
            <div className="d-flex w-100 flex-column text-start mb-3 ">
              <h3 className="login-card-text fw-bold white-text">Welcome</h3>
              <p className="login-card-text text mb-1">
                Hello,{" "}
                <strong
                  style={{
                    color: "#000000",
                    fontSize: "14px",
                  }}
                >
                  {email}
                </strong>
                . You are associated with below clients. Please choose one to
                continue.
              </p>
            </div>
            <div className="d-flex w-100 flex-column align-items-center gap-2">
              <div
                className="clientdiv col-sm-12 mb-3"
                style={{ height: "auto", overflowY: "scroll" }}
              >
                <div className="form-floating">
                  {loading ? (
                    <p className="text-start">Loading client data...</p>
                  ) : clientData && clientData.clients?.length > 0 ? (
                    clientData.clients.map((client, index) => (
                      <div
                        key={index}
                        className="p-2 mb-2"
                        style={{
                          border: "1px solid black",
                          borderRadius: "10px",
                          backgroundColor: "rgba(255,255,255,0.05)",
                        }}
                      >
                        <p className="fs-6 mb-0 fw-semibold">
                          {client.clientName}
                        </p>

                        <p
                          className="fs-6 mb-0 fw-semibold text-black"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            // window.open(`${client.subDomainURL}`, "_self")
                            {
                              // const sliced = client.subDomainURL.substring(client.subDomainURL.indexOf("/client"));
                              // window.history.replaceState(null, "", sliced);
                              // setStep("login");
                              // setClientSubdomain(client.subDomainURL)}
                              const slicedPath = client.subDomainURL.substring(
                                client.subDomainURL.indexOf("/client")
                              );
                              sessionStorage.setItem("userEmail", email);
                              window.open(slicedPath, "_self");
                            }
                          }
                        >
                          {client.subDomainURL}
                        </p>
                      </div>
                    ))
                  ) : (
                    <p className="text-start">No client data found.</p>
                  )}
                  {/* </div> */}
                </div>
              </div>
              <div className="col-sm-12 mb-3 mt-2 flex-column gap-3 flex-sm-row text-end">
                <button
                  type="submit"
                  className="buttonStyle px-0"
                  style={{
                    color: "black",
                  }}
                  onClick={() => {
                    setStep("checkEmail");
                    setEmail("");
                    resetValue();
                  }}
                >
                  <i className="fa fa-arrow-left mt-1 "></i> Back to Login
                </button>
              </div>

              <>
                {loginError && <div className="text-danger">{loginError}</div>}
              </>
            </div>
            <div className="terms-conditions">
              <p className="mb-0">
                BY CONTINUING, YOU AGREE TO OUR{" "}
                <Link
                  to="/PrivacyPolicy"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  TERMS OF SERVICE
                </Link>{" "}
                AND{" "}
                <Link
                  to="/PrivacyPolicy"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  PRIVACY POLICY
                </Link>
              </p>
              <p className="mt-4 mb-0">COPYRIGHT@2025, FIRE INSPECT</p>
            </div>
          </div>
        </div>
      )}

      {step === "enter otp client" && (
        <div className="login-container d-flex justify-content-center">
          <div className="card login-card align-items-center">
            <div className="d-flex w-100 flex-column text-start mb-3">
              <h3 className="login-card-text fw-bold white-text">
                Client OnBoarding
              </h3>
              <p className="login-card-text text">
                Enter the 6-digit code sent to{" "}
                <strong
                  style={{
                    // marginLeft: "5px",
                    color: "#000000",
                    fontSize: "14px",
                  }}
                >
                  {email}
                </strong>
                . OTP is valid for 10 minutes.
              </p>
            </div>
            <div className="d-flex w-100 mt-3 flex-column align-items-center gap-2">
              <form className="w-100">
                <div className="col-sm-12 mb-3 d-flex gap-3 login-otp">
                  <input
                    type="text"
                    className="form-control-box1"
                    maxLength="1"
                    value={otpValues.digit1}
                    onChange={(e) => {
                      setOTPValue(e.target.value, "digit1", 0);
                    }}
                    onKeyDown={(e) => handleKeyDown(e, 0)}
                    ref={(el) => (inputRefs.current[0] = el)}
                    onPaste={handlePaste}
                  />
                  <input
                    type="text"
                    className="form-control-box2"
                    maxLength="1"
                    value={otpValues.digit2}
                    onChange={(e) => {
                      setOTPValue(e.target.value, "digit2", 1);
                    }}
                    onKeyDown={(e) => handleKeyDown(e, 1)}
                    ref={(el) => (inputRefs.current[1] = el)}
                  />
                  <input
                    type="text"
                    className="form-control-box3"
                    maxLength="1"
                    value={otpValues.digit3}
                    onChange={(e) => {
                      setOTPValue(e.target.value, "digit3", 2);
                    }}
                    onKeyDown={(e) => handleKeyDown(e, 2)}
                    ref={(el) => (inputRefs.current[2] = el)}
                  />
                  <input
                    type="text"
                    className="form-control-box4"
                    maxLength="1"
                    value={otpValues.digit4}
                    onChange={(e) => {
                      setOTPValue(e.target.value, "digit4", 3);
                    }}
                    onKeyDown={(e) => handleKeyDown(e, 3)}
                    ref={(el) => (inputRefs.current[3] = el)}
                  />
                  <input
                    type="text"
                    className="form-control-box5"
                    maxLength="1"
                    value={otpValues.digit5}
                    onChange={(e) => {
                      setOTPValue(e.target.value, "digit5", 4);
                    }}
                    onKeyDown={(e) => handleKeyDown(e, 4)}
                    ref={(el) => (inputRefs.current[4] = el)}
                  />
                  <input
                    type="text"
                    className="form-control-box6"
                    maxLength="1"
                    value={otpValues.digit6}
                    onChange={(e) => {
                      setOTPValue(e.target.value, "digit6", 5);
                    }}
                    onKeyDown={(e) => handleKeyDown(e, 5)}
                    ref={(el) => (inputRefs.current[5] = el)}
                  />
                </div>

                <div className="col-sm-12 text-center">
                  <p
                  // style={{ width: "150px", marginLeft: "-20px !important" }}
                  >
                    <span
                      onClick={isResendDisabled ? null : handleResend}
                      className="resend"
                      style={{
                        cursor: isResendDisabled ? "not-allowed" : "pointer",
                      }}
                    >
                      {isResendDisabled
                        ? `OTP sent to your email. Resend OTP in ${counter}s`
                        : "Resend OTP"}
                    </span>
                  </p>
                  <button
                    type="submit"
                    className="btn-primary mb-3 w-100"
                    onClick={(e) => handleVerifyOTP(e)}
                    disabled={
                      loading ||
                      Object.values(otpValues).some((digit) => digit === "")
                    }
                  >
                    {loading ? "Please Wait..." : "Verify OTP"}
                  </button>
                </div>

                {/* </div> */}
                <div className="col-sm-12 mb-3 mt-2 flex-column gap-3 flex-sm-row text-end">
                  <button
                    type="submit"
                    className="buttonStyle"
                    style={{
                      color: "black",
                    }}
                    onClick={() => {
                      setStep("checkEmail");
                      setEmail("");
                      resetValue();
                    }}
                  >
                    <i className="fa fa-arrow-left me-2"></i> Back to Login
                  </button>
                </div>
              </form>
            </div>
            <div className="terms-conditions">
              <p className="mb-0">
                BY CONTINUING, YOU AGREE TO OUR{" "}
                <Link
                  to="/PrivacyPolicy"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  TERMS OF SERVICE
                </Link>{" "}
                AND{" "}
                <Link
                  to="/PrivacyPolicy"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  PRIVACY POLICY
                </Link>
              </p>
              <p className="mt-4 mb-0">COPYRIGHT@2025, FIRE INSPECT</p>
            </div>
          </div>
        </div>
      )}
      {step === "enter otp" && (
        <>
          <div className="login-container d-flex justify-content-center">
            <div className="card login-card align-items-center">
              <div className="d-flex w-100 flex-column text-start mb-3">
                <h3 className="login-card-text fw-bold white-text">Welcome</h3>
                <p className="login-card-text text">
                  Enter the 6-digit code sent to{" "}
                  <strong
                    style={{
                      // marginLeft: "5px",
                      color: "#000000",
                      fontSize: "14px",
                    }}
                  >
                    {email}
                  </strong>
                  . This OTP is valid for 10 minutes only.
                </p>
              </div>
              <div className="d-flex w-100 mt-3 flex-column align-items-center gap-2">
                <form className="w-100">
                  <div className="col-sm-12 mb-3 d-flex gap-3 login-otp">
                    <input
                      type="text"
                      className="form-control-box1"
                      maxLength="1"
                      value={otpValues.digit1}
                      onChange={(e) => {
                        setOTPValue(e.target.value, "digit1", 0);
                      }}
                      onKeyDown={(e) => handleKeyDown(e, 0)}
                      ref={(el) => (inputRefs.current[0] = el)}
                      onPaste={handlePaste}
                    />
                    <input
                      type="text"
                      className="form-control-box2"
                      maxLength="1"
                      value={otpValues.digit2}
                      onChange={(e) => {
                        setOTPValue(e.target.value, "digit2", 1);
                      }}
                      onKeyDown={(e) => handleKeyDown(e, 1)}
                      ref={(el) => (inputRefs.current[1] = el)}
                    />
                    <input
                      type="text"
                      className="form-control-box3"
                      maxLength="1"
                      value={otpValues.digit3}
                      onChange={(e) => {
                        setOTPValue(e.target.value, "digit3", 2);
                      }}
                      onKeyDown={(e) => handleKeyDown(e, 2)}
                      ref={(el) => (inputRefs.current[2] = el)}
                    />
                    <input
                      type="text"
                      className="form-control-box4"
                      maxLength="1"
                      value={otpValues.digit4}
                      onChange={(e) => {
                        setOTPValue(e.target.value, "digit4", 3);
                      }}
                      onKeyDown={(e) => handleKeyDown(e, 3)}
                      ref={(el) => (inputRefs.current[3] = el)}
                    />
                    <input
                      type="text"
                      className="form-control-box5"
                      maxLength="1"
                      value={otpValues.digit5}
                      onChange={(e) => {
                        setOTPValue(e.target.value, "digit5", 4);
                      }}
                      onKeyDown={(e) => handleKeyDown(e, 4)}
                      ref={(el) => (inputRefs.current[4] = el)}
                    />
                    <input
                      type="text"
                      className="form-control-box6"
                      maxLength="1"
                      value={otpValues.digit6}
                      onChange={(e) => {
                        setOTPValue(e.target.value, "digit6", 5);
                      }}
                      onKeyDown={(e) => handleKeyDown(e, 5)}
                      ref={(el) => (inputRefs.current[5] = el)}
                    />
                  </div>
                  <div className="col-sm-12 text-center">
                    <p
                    // style={{ width: "150px", marginLeft: "-20px !important" }}
                    >
                      <span
                        onClick={isResendDisabled ? null : handleResend}
                        className="resend"
                        style={{
                          cursor: isResendDisabled ? "not-allowed" : "pointer",
                        }}
                      >
                        {isResendDisabled
                          ? `OTP sent to your email. Resend OTP in ${counter}s`
                          : "Resend OTP"}
                      </span>
                    </p>
                    <button
                      type="submit"
                      className="btn-primary mb-3 w-100"
                      onClick={(e) => handleVerifyOTP(e)}
                      disabled={
                        loading ||
                        Object.values(otpValues).some((digit) => digit === "")
                      }
                    >
                      {loading ? "Please Wait..." : "Verify OTP"}
                    </button>
                  </div>

                  <div className="col-sm-12 mb-3 mt-2 flex-column gap-3 flex-sm-row text-end">
                    {/* <a href="#">Reset your password</a> */}
                    <button
                      className="buttonStyle"
                      onClick={() => {
                        setEmail("");
                        resetValue();
                        setStep("checkEmail");
                      }}
                      style={{
                        color: "black",
                      }}
                    >
                      Sign in to a different account
                    </button>
                  </div>
                </form>
              </div>
              <div className="terms-conditions">
                <p className="mb-0">
                  BY CONTINUING, YOU AGREE TO OUR{" "}
                  <Link
                    to="/PrivacyPolicy"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    TERMS OF SERVICE
                  </Link>{" "}
                  AND{" "}
                  <Link
                    to="/PrivacyPolicy"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    PRIVACY POLICY
                  </Link>
                </p>
                <p className="mt-4 mb-0">COPYRIGHT@2025, FIRE INSPECT</p>
              </div>
            </div>
          </div>
        </>
      )}
      {step === "reset password" && (
        <div className="login-container d-flex justify-content-center">
          <div className="card login-card align-items-center">
            <div className="d-flex w-100 flex-column text-start mb-3 ">
              <h3 className="login-card-text fw-bold white-text">Welcome</h3>
              <p className="login-card-text text">
                To proceed with resetting your password, check that the email
                you entered is the one you may have used before.
              </p>
            </div>
            <div className="d-flex w-100 mt-3 flex-column align-items-center gap-2">
              <form className="w-100">
                <div className="col-sm-12 mb-3">
                  <div className="form-floating">
                    <p className="logtext text-start">Email Address</p>
                    <input
                      type="email"
                      value={email}
                      className="form-controlinputbox  ps-5"
                      id="floatingInput"
                      disabled
                      onChange={(e) => handleEmail(e)}
                      // placeholder="Enter your email address"
                    />
                    <img src={emaillogo} className="input-icon" alt="logo" />
                  </div>
                </div>

                <div className="col-sm-12">
                  <button
                    disabled={!email}
                    type="submit"
                    className="btn-primary mb-3 w-100"
                    onClick={() => {
                      setStep("change password");
                      setOtpValues(defaultOTPObj);
                    }}
                  >
                    {loading ? "Please Wait..." : "Continue"}
                  </button>
                </div>
                <div className="col-sm-12 mb-3 mt-2 flex-column gap-3 flex-sm-row text-end">
                  {/* <a href="#">Reset your password</a> */}
                  <button
                    className="buttonStyle"
                    onClick={() => {
                      setStep("checkEmail");
                      setEmail("");
                      resetValue();
                    }}
                    style={{
                      color: "black",
                    }}
                  >
                    <i className="fa fa-arrow-left me-1"></i> Sign in to a
                    different account
                  </button>
                </div>
              </form>
            </div>
            <div className="terms-conditions">
              <p className="mb-0">
                BY CONTINUING, YOU AGREE TO OUR{" "}
                <Link
                  to="/PrivacyPolicy"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  TERMS OF SERVICE
                </Link>{" "}
                AND{" "}
                <Link
                  to="/PrivacyPolicy"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  PRIVACY POLICY
                </Link>
              </p>
              <p className="mt-4 mb-0">COPYRIGHT@2025, FIRE INSPECT</p>
            </div>
          </div>
        </div>
      )}
      {step === "change password" && (
        <div className="login-container d-flex justify-content-center">
          <div className="card login-card align-items-center">
            <div className="d-flex w-100 flex-column text-start mb-3 ">
              <h3 className="login-card-text fw-bold white-text">Welcome</h3>
              <p className="login-card-text text">Enter new password</p>
            </div>
            <div className=" d-flex w-100 mt-3 flex-column align-items-center gap-2">
              <form className="w-100" onSubmit={handleResetPassword}>
                <div className="col-sm-12 mb-3">
                  <div
                    className="form-floating"
                    // style={{ position: "relative" }}
                  >
                    <p className="logtext text-start">New password</p>
                    <input
                      className="form-controlinputbox ps-5 pe-5"
                      id="passwordInput"
                      type={showPassword ? "text" : "password"}
                      // placeholder="Enter your new password"
                      value={password}
                      onChange={(e) => handlePassword(e.target.value)}
                      required
                    />
                    <img
                      src={passlogo}
                      className="input-icon"
                      // style={{ marginTop: "16px", marginLeft: "20px" }}
                      alt="logo"
                    />
                    <i
                      className={`fa-solid mt-4 ${
                        showPassword ? "fa-eye-slash" : "fa-eye"
                      } fa-sm showAndHidePass`}
                      onClick={resetScreenShowPass}
                    ></i>
                  </div>
                  <div>
                    {strengthNew > 0 ? (
                      <progress
                        hidden={password.length === 0}
                        className={`password strength-${strengthNew}`}
                        value={strengthNew}
                        max="4"
                      />
                    ) : null}
                  </div>
                  <div
                    className={`feedback strength-${strengthNew}`}
                    hidden={password.length === 0}
                  >
                    {feedback}
                  </div>
                </div>
                <div className="col-sm-12 mb-3">
                  <div
                    className="form-floating"
                    // style={{ position: "relative" }}
                  >
                    <p className="logtext text-start">Re-Enter Password</p>
                    <input
                      className="form-controlinputbox ps-5 pe-5"
                      id="floatingInput"
                      type={showConfirmPassword ? "text" : "password"}
                      // placeholder="       Confirm New Password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      required
                    />
                    <img
                      src={passlogo}
                      className="input-icon"
                      // style={{ marginTop: "16px", marginLeft: "20px" }}
                      alt="logo"
                    />
                    <i
                      className={`fa-solid mt-4 ${
                        showConfirmPassword ? "fa-eye-slash" : "fa-eye"
                      } fa-sm  showAndHidePass`}
                      onClick={confirmShowPassword}
                    ></i>
                  </div>
                </div>
                <>
                  {loginError ||
                    (true && <div className="text-danger">{loginError}</div>)}
                </>
                <div className="col-sm-12 mb-2 ">
                  <button
                    type="submit"
                    className="btn-primary mb-3 w-100"
                    disabled={enableCountniue}
                  >
                    {loading ? "Please Wait..." : "Continue"}
                  </button>
                </div>
                <div className="col-sm-12 mb-3 mt-2 flex-column gap-3 flex-sm-row text-end">
                  {/* <a href="#">Reset your password</a> */}
                  <button
                    className="buttonStyle"
                    onClick={() => {
                      setEmail("");
                      resetValue();
                      setStep("checkEmail");
                    }}
                    style={{
                      color: "black",
                    }}
                  >
                    Sign in to a different account
                  </button>
                </div>
              </form>
            </div>
            <div className="terms-conditions">
              <p className="mb-0">
                BY CONTINUING, YOU AGREE TO OUR{" "}
                <Link
                  to="/PrivacyPolicy"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  TERMS OF SERVICE
                </Link>{" "}
                AND{" "}
                <Link
                  to="/PrivacyPolicy"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  PRIVACY POLICY
                </Link>
              </p>
              <p className="mt-4 mb-0">COPYRIGHT@2025, FIRE INSPECT</p>
            </div>
          </div>
        </div>
      )}

      {step === "login" && (
        <div className="login-container d-flex justify-content-center">
          <div className="card login-card align-items-center">
            <div className="d-flex w-100 flex-column text-start mb-3 ">
              <h3 className="login-card-text fw-bold white-text">Welcome</h3>
              <p className="login-card-text text">
                Enter your password to continue
              </p>
            </div>
            <div className="d-flex w-100 mt-3 flex-column align-items-center gap-2">
              <form className="w-100" onSubmit={handleLogin}>
                <div className="form-floating">
                  <p
                    className="logtext text-start"
                    style={{ fontWeight: "500" }}
                  >
                    Email Address
                  </p>
                  <input
                    type="email"
                    className="form-controlinputbox  ps-5"
                    id="floatingInput"
                    value={email}
                    disabled
                    required
                  />
                  <img src={emaillogo} className="input-icon" alt="logo" />
                </div>

                <div
                  className="form-floating mb-3"
                  // style={{ position: "relative" }}
                >
                  <p className="logtext text-start">Password</p>

                  <input
                    className="form-controlinputbox ps-5 pe-5"
                    id="passwordInput"
                    type={showPasswordMain ? "text" : "password"}
                    // placeholder="Enter your password"
                    value={password}
                    onChange={(e) => handlePassword(e.target.value)}
                    required
                    style={{
                      height: "50px",
                      paddingRight: "40px",
                    }}
                  />
                  <img
                    src={passlogo}
                    className="input-icon"
                    // style={{ marginTop: "16px", marginLeft: "20px" }}
                    alt="logo"
                  />

                  <i
                    className={`fa-solid mt-4  ${
                      showPasswordMain ? "fa-eye-slash" : "fa-eye"
                    } fa-sm  showAndHidePassl`}
                    onClick={mainScreenShowPass}
                    style={{
                      position: "absolute",
                      right: "12px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#6c6c6c",
                    }}
                  ></i>
                </div>

                <div className="col-sm-12">
                  <button type="submit" className="btn-primary mb-3 w-100">
                    {loading ? "Please Wait..." : "Sign In"}
                  </button>
                </div>
                <>
                  {loginError && (
                    <div className="text-danger ">{loginError}</div>
                  )}
                </>

                <div className="forgotpass col-sm-12 mb-2 mt-3  text-center d-flex justify-content-sm-between flex-column gap-3 flex-sm-row">
                  <button
                    className="buttonStyle"
                    onClick={() => {
                      resetValue();
                      setStep("reset password");
                    }}
                    style={{
                      color: "black",
                    }}
                  >
                    Forgot password?
                  </button>
                  <button
                    className="buttonStyle"
                    onClick={() => {
                      setEmail("");
                      resetValue();
                      setStep("checkEmail");
                    }}
                    style={{
                      color: "black",
                    }}
                  >
                    Sign in to a different account
                  </button>
                </div>
              </form>
            </div>
            <div className="terms-conditions">
              <p className="mb-0">
                BY CONTINUING, YOU AGREE TO OUR{" "}
                <Link
                  to="/PrivacyPolicy"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  TERMS OF SERVICE
                </Link>{" "}
                AND{" "}
                <Link
                  to="/PrivacyPolicy"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  PRIVACY POLICY
                </Link>
              </p>
              <p className="mt-4 mb-0">COPYRIGHT@2025, FIRE INSPECT</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LogIn;
